import { createContext, useContext } from 'react'
import type { PendingFile } from '../lib/uploads.js'

export interface CapturePrefill {
  text?: string
  files?: PendingFile[]
  targetId?: string
  mode?: 'idea' | 'direct'
  /** Feedback on a build (`origin.buildId`). */
  buildId?: string
}

export interface StartPrefill {
  prompt?: string
  projectId?: string
  workstreamId?: string
  workstreamName?: string
  taskId?: string
  machineId?: string
}

export interface AppUi {
  openCapture(prefill?: CapturePrefill): void
  openStart(prefill?: StartPrefill): void
  openPalette(): void
  /** The `?` keyboard cheat sheet. */
  openShortcuts?(): void
}

export const AppUiContext = createContext<AppUi>({
  openCapture() {},
  openStart() {},
  openPalette() {},
  openShortcuts() {},
})

export const useAppUi = () => useContext(AppUiContext)
